var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94891 8.60073L8.34681 8.60073L8.77183 8.17426L12.5331 4.40019L12.533 4.40011L12.5382 4.39517C12.8118 4.13596 12.9479 3.81726 12.9479 3.42133C12.9479 3.0254 12.8118 2.70671 12.5382 2.4475L12.5381 2.4476L12.5322 2.44161L11.5706 1.46717C11.5704 1.46701 11.5703 1.46684 11.5701 1.46667C11.3011 1.19792 10.98 1.06543 10.592 1.06543C10.2145 1.06543 9.88681 1.19681 9.59833 1.4695L1.24392 9.83674L1.24378 9.83688C0.974698 10.106 0.842041 10.4272 0.842041 10.8154C0.842041 11.193 0.973421 11.5207 1.24612 11.8091L9.60052 20.1507L9.60065 20.1508C9.87971 20.4299 10.2058 20.5654 10.592 20.5654C10.9683 20.5654 11.2905 20.4309 11.5706 20.1508L11.5718 20.1497L12.5334 19.2009C12.5336 19.2007 12.5338 19.2005 12.534 19.2003C12.8126 18.9214 12.9479 18.5955 12.9479 18.2095C12.9479 17.8233 12.8124 17.4972 12.5334 17.2181L8.77213 13.4569L8.34536 13.0301L8.94891 13.0301L17.9861 13.0301C18.3626 13.0301 18.6538 12.8982 18.8819 12.635C19.1179 12.3628 19.2381 12.0349 19.2381 11.637L19.2381 9.99386C19.2381 9.596 19.1179 9.26808 18.8819 8.99585C18.6538 8.73264 18.3626 8.60073 17.9861 8.60073L8.94891 8.60073Z",
    fill: "white",
    stroke: "#006BFF",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c1c6a040f6a93a35c5f1fc60e89c1337.svg";
export { ForwardRef as ReactComponent };